import searchIcon from 'bundle-text:../assets/icons/search.svg'
import { useEffect, useState } from 'react'
import { useMarketplace } from '../context'

export function Search() {
    const { setSearch, state } = useMarketplace()
    const [input, setInput] = useState('')

    useEffect(() => {
        setInput(state.search)
    }, [state.search])

    useEffect(() => {
        const timer = setTimeout(() => setSearch(input), 400)
        return () => clearTimeout(timer)
    }, [input])

    return (
        <label className='flex-1 flex flex-row items-center gap-4 border p-2 px-4 rounded border-white/20 focus-within:border-violet-500 min-w-0'>
            <span className='pointer-events-none' dangerouslySetInnerHTML={{ __html: searchIcon }}></span>
            <input
                type='text'
                placeholder='Search Items'
                className='flex-1 text-inherit bg-transparent outline-none font-bold placeholder:text-white/20 min-w-0'
                value={input}
                onChange={(e) => setInput(e.target.value)}
            />
        </label>
    )
}
